module.exports = __webpack_public_path__ + "static/media/p5preview.c71d2691.jpg";